import { DateService } from "../../../service/DateService";
import { IEvaluation } from "../../../model/evaluation/Evaluation";

export interface TEvaluationPresentationModel {
  id: number;
  date: string;
  result?: string;
  reportEvaluationStatus: string;
  errorLog?: string;
}

const EvaluationPresentationModel = (
  data: IEvaluation
): TEvaluationPresentationModel => {
  const date = DateService().formaDateWithTime(data.date);
  return {
    id: data.id,
    date,
    result: data.result,
    reportEvaluationStatus: data.reportEvaluationStatus,
    errorLog: data.errorLog
  };
};

export default EvaluationPresentationModel;
